
export const fronturls = {
	//Front end URLS to be entered here
	Home:"/home",
	Help:"/help",
	ContactUs:"/contact-us",
	StudentLogin:"/student-login",
	AdminLogin:"/admin-login",
	Acknowledgements:"/acknowledgements",
	StudentDashboard:'/student-dashboard',
	Instructions:"/instructions",
	AdminDashboard:"/admin-dashboard",
	CodeGeneration:"/generate-codes",
	QuestionListing:"/question-listing",
	ForgotPassword: "/forgot-password",
	Resources:"/resources",
	MyScores:"/my-scores",
	Feedback:"/feedback",
	Users:"/users",
	AdminUsers:"/admin-users",
	StudentUsers:"/student-users",
	Logout:"/logout",
	MyProfile:"/my-profile",
	Tests:"/test-listing",
	TestScore:"/test-score",
	Images:"/image-listing",
	ImageQuizzes:"/image-quiz-listing",
	Videos:"/video-listing",
	VideoPreview:"/video-preview",
	Flashcards:"/flashcard-listing",
	ResetPassword: "/reset-password",
	Registration: "/registration",
	Profile: "/profile",
	Listing: '/listing',
	FlashcardQuestions: "/flashcard-questions",
	FlashcardView: "/flashcard-view",
	StartTest: "/start-test",
	ResumeTest: "/resume-test",
	EditUser: "/edit-user",
	ImageView: "/image-view",
	ImageQuizInstruction: "/image-quiz-instructions",
	Activation: "/activation",
	TestResult: "/test-results",
	TakeTest: "/take-test",
	QuestionUpdate: "/question-update",
	ImageQuizPreview: "/preview-image-quiz",
	ImageQuiz: "/image-quiz",
	RetakeTest: "/retake-test",
	ReviewIncorrect: "/review-incorrect",
	IQReviewIncorrect: "/image-quiz-review-incorrect",
	ImageQuizResults: "/image-quiz-results",
	ImageQuizUpdate: "/image-quiz-update",
	ViewPdf: "/view-pdf",
	ImageUpdate: "/image-update",
	ResendEmail: "/resend-email",
	EditFlashcard: "/edit-flashcard",
	InvalidBookCode: "/why-is-my-book-code-invalid",
	AccessOnlineResources: "/how-do-i-access-the-online-resources",
	FindAccessCode: "/how-do-i-find-the-access-code-to-register-for-the-practice-exams",
	UseMyCode: "/can-someone-else-use-my-subscription",
	DidNotReceiveMail: "/i-did-not-receive-an-email-after-registration-what-do-i-do",
	NotReceiveMails:"/i-am-not-receiving-mails-from-this-site",
	ForgottenUsernamePassword: "/what-should-i-do-if-i-have-forgotten-my-username-or-password",
	AccAccessInfo: "/how-long-will-i-be-able-to-access-my-account",
	CannotAccessOnlineResources: "/what-should-i-do-if-i-cannot-access-the-online-resources",
	CannotLoginAccount: "/why-can-t-i-login-my-account",
	UniversityListing: "/university-master",
	AddUniversity: "/add-university",
	VideoEdit: "/video-edit",
	CodesListing: "/book-code-list",
	AddImageQuiz: "/image-quiz-add",
	AddQuestion: "/question-add",
	AddFlashcard: "/flashcard-add",
	DocumentsListing: "/document-listing",
	ViewDocument: "/view-document",
	ImageQuizScores: "/image-quiz-scores",
	Policies: "/policies",
	Settings: "/settings",
	ReviewAll: "/review-all",
	CronActivity: "/cron-activity",
	Responsedata: "/response-data",
	FlashcardAnalysis: "/flashcard-analysis",
}
